import React from "react";
import classNames from "classnames/bind";
import ModalInfoEvent from "./ModalInfoEvent";
import ModalCountPositionCarPark from "./ModalCountPositionCarPark";
import CanvasDraw from "../CanvasDraw";
import CanvasRegion from "../CanvasRegion";
import styles from "./StreamCam.module.css";

const cx = classNames.bind(styles);

/**
 * Camera overlays component showing event info, car park info, and regions
 */
const CameraOverlays = ({
    eventInfo,
    countPositionCarPart,
    showModalPositionCarPark,
    showModalRegion,
    screen,
    isFullScreen,
    item,
    listPosition,
    refWrapperVideo,
    refreshCamera,
}) => {
    return (
        <>
            {/* Event Info Modal (Face Recognition, License Plate) */}
            {eventInfo?.show && (
                <div className={cx("modal")}>
                    <ModalInfoEvent
                        detail={eventInfo}
                        screen={screen?.total}
                        fullScreen={isFullScreen}
                    />
                </div>
            )}

            {/* Car Park Count Modal */}
            {countPositionCarPart?.show && (
                <div className={cx("modal")}>
                    <ModalCountPositionCarPark
                        detail={countPositionCarPart}
                        screen={screen?.total}
                        fullScreen={isFullScreen}
                    />
                </div>
            )}

            {/* Car Park Position Canvas */}
            {showModalPositionCarPark && (
                <div className={cx("modal-view-position")}>
                    <CanvasDraw
                        cameraCode={item?.code}
                        listPosition={listPosition}
                        width={refWrapperVideo?.current?.clientWidth}
                        height={refWrapperVideo?.current?.clientHeight}
                    />
                </div>
            )}

            {/* Region Detection Canvas */}
            {showModalRegion?.show && (
                <div className={cx("modal-view-position")}>
                    <CanvasRegion
                        cameraCode={item?.code}
                        listPosition={showModalRegion?.region}
                        width={refWrapperVideo?.current?.clientWidth}
                        height={refWrapperVideo?.current?.clientHeight}
                        codeService={"20230222000000000004"}
                        refreshCamera={refreshCamera}
                    />
                </div>
            )}
        </>
    );
};

export default CameraOverlays;

